import { render, staticRenderFns } from "./decoration_nav_list.vue?vue&type=template&id=194e0b4f&"
import script from "./decoration_nav_list.vue?vue&type=script&lang=js&"
export * from "./decoration_nav_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports